import React, { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import MaterialTable from '@material-table/core';
import { Add, Edit } from '@mui/icons-material';
import materialTableIcons from '../../common/materialTableIcons';
import { asMaterialTableData } from '../../common/materialTableUtils';

import NewUserScreen from './NewUserScreen';
import { requestEmployees } from '../actions/administrate_users';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  iframe: {
    width: '100%',
    minHeight: 640,
    border: 0,
  },
}));

const AdministrateUsersScreen = () => {
  const [open, setOpen] = React.useState(false);
  const [item, setItem] = React.useState({});
  const classes = useStyles();
  const dispatch = useDispatch();
  const employees = useSelector((state) => state.employees);

  useEffect(() => {
    dispatch(requestEmployees());
  }, []);

  const handleClickOpen = (employee = {}) => {
    setItem(employee);
    setOpen(true);
  };

  const handleClose = (shouldRefresh) => {
    if (shouldRefresh) {
      dispatch(requestEmployees());
    }
    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <Typography
        variant="h2"
      >
        Listado de Agentes
      </Typography>
      <MaterialTable
        icons={materialTableIcons}
        title=""
        columns={[
          { title: 'Nombre', field: 'displayName' },
          { title: 'Email', field: 'email' },
          { title: 'Cuenta Habilitada', field: 'accountEnabled', type: 'boolean' },
        ]}
        data={asMaterialTableData(employees?.data)}
        options={{
          selection: false,
          actionsColumnIndex: -1,
          columnsButton: false,
          searchFieldVariant: 'outlined',
        }}
        isLoading={employees.loading}
        actions={[
          {
            icon: () => <Add />,
            tooltip: 'Add User',
            isFreeAction: true,
            onClick: () => handleClickOpen(),
          },
          {
            icon: () => <Edit />,
            tooltip: 'Editar',
            isFreeAction: false,
            onClick: (event, rowData) => handleClickOpen(rowData),
          },
        ]}

      />
      {open && <NewUserScreen open={open} handleClose={handleClose} data={item} />}
    </div>
  );
  // }
};

export default AdministrateUsersScreen;
